import * as React from 'react';
import * as s from './PriceQuoteView.scss';
import * as get from 'lodash.get';
import * as _ from 'lodash';
import { Text } from 'wix-style-react';
import LineItems from '../DocParts/LineItems';
import Totals from './Totals';
import Customer from './Customer';
import Comments from '../DocParts/Comments';
import { PriceQuotesBusinessInfo } from '../DocParts/PriceQuotesBusinessInfo/PriceQuotesBusinessInfo';
import QuoteInfo from './QuoteInfo';
import Status from './Status';
import AscendLogo from '../AscendLogo';
import { translate } from 'react-i18next';
import { WithTitleLoader } from '../loaders/loaders-builder';
var Title = WithTitleLoader(function (_a) {
    var priceQuote = _a.priceQuote;
    return (React.createElement("div", { className: s.title },
        React.createElement(Text, { dataHook: "price-quote-title", weight: "bold", size: "tiny" }, priceQuote.title)));
});
var PriceQuoteView = function (_a) {
    var priceQuote = _a.priceQuote, businessInfo = _a.businessInfo, locale = _a.locale, _b = _a.isUoU, isUoU = _b === void 0 ? false : _b, _c = _a.ascend, ascend = _c === void 0 ? false : _c, t = _a.t, onQuotePreviewReady = _a.onQuotePreviewReady;
    var _d = React.useState(false), businessInfoReady = _d[0], setBusinessInfoReady = _d[1];
    var _e = React.useState(false), quoteReady = _e[0], setQuoteReady = _e[1];
    React.useEffect(function () {
        !!businessInfo && !_.isEmpty(businessInfo) && setBusinessInfoReady(true);
        !!priceQuote && !_.isEmpty(priceQuote) && setQuoteReady(true);
    }, [businessInfo, priceQuote]);
    var lineItems = get(priceQuote.lineItems, 'lineItems', []).map(function (_a) {
        var name = _a.name, description = _a.description, price = _a.price, quantity = _a.quantity;
        var lineItemQuantity = quantity.serializedValue || 0;
        var lineItemPrice = price.serializedValue || 0;
        var lineItemTotal = lineItemQuantity * lineItemPrice;
        return {
            name: name,
            description: description,
            price: lineItemPrice,
            quantity: lineItemQuantity,
            total: lineItemTotal,
        };
    });
    //TODO: Fix businessInfo type and remove as any
    return (React.createElement("div", null,
        React.createElement("div", { className: s.priceQuoteView },
            React.createElement("div", { className: s.details },
                React.createElement("div", { className: s.detail },
                    React.createElement(PriceQuotesBusinessInfo, { businessInfo: businessInfo, onImageReady: onQuotePreviewReady, isReady: businessInfoReady }),
                    React.createElement(Title, { priceQuote: priceQuote, isReady: quoteReady }),
                    React.createElement(Customer, { isReady: quoteReady, customer: priceQuote.customer })),
                React.createElement("div", { className: s.detail },
                    React.createElement(Status, { isReady: quoteReady, status: priceQuote.status, isUoU: isUoU }),
                    React.createElement(QuoteInfo, { isReady: quoteReady, priceQuote: priceQuote, locale: locale }))),
            React.createElement(LineItems, { lineItems: lineItems, currencyCode: priceQuote.currencyCode, locale: locale }),
            React.createElement(Totals, { priceQuote: priceQuote, locale: locale }),
            React.createElement(Comments, { metaData: priceQuote.metaData }),
            ascend && (React.createElement("div", { className: s.ascendFooter, "data-hook": "ascend-footer" },
                React.createElement(Text, { weight: "normal", size: "tiny", secondary: true }, t('invoice-view:price-quote.created-with')),
                React.createElement("div", { className: s.ascendLogo },
                    React.createElement(AscendLogo, null)))))));
};
export default translate(['invoice-view', 'locale-data'], { wait: true })(PriceQuoteView);
//# sourceMappingURL=PriceQuoteView.js.map